import * as React from 'react';
import { AgeInput } from './AgeInput';

import { QuestionLabel } from './QuestionLabel';
import { ChildEnrollmentDetails } from './SubsidyCalculationFormContainer';
import SelectionControlGroup from 'react-md/lib/SelectionControls/SelectionControlGroup';

interface Props {
    enrolledChild: ChildEnrollmentDetails;
    id: string;
    onDetailsUpdated: (enrolledChild: ChildEnrollmentDetails) => void;
}

interface State {
}

export class EnrolledChildDetails extends React.Component<Props, State> {
    public render() {
        const ageQuestion = this.renderAgeQuestion();
        const sessionsQuestion = this.renderSessionsQuestion();
        return (
            <div className="enrolled-child-details">
                {ageQuestion}
                {sessionsQuestion}
            </div>);
    }

    private renderAgeQuestion(): JSX.Element {
        const details = this.props.enrolledChild;
        return (
            <QuestionLabel labelText="How old is the child?">
                <AgeInput ageInMonths={details.ageInMonths} onChange={this.setChildAge} />
            </QuestionLabel>
        )
    }

    private renderSessionsQuestion(): JSX.Element {
        const details = this.props.enrolledChild;

        const numberOfSessionsOptions = Array.from(new Array(5), (_, index) => {
            const numberOfSessions = `${index+1}`;
            return {
              label: numberOfSessions,
              value: numberOfSessions
            };
          });

        return (
            <QuestionLabel labelText="How many days per week will this child attend long day care?">
                <SelectionControlGroup
                    id={`enrolledChildSessionsPerWeekInput_${this.props.id}`}
                    name={`enrolledChildSessionsPerWeekInput_${this.props.id}`}
                    type="radio"
                    value={`${details.attendSessionsPerWeek.toString()}`}
                    onChange={this.setWeeklySessions}
                    inline={true}
                    controls={numberOfSessionsOptions}
                />
            </QuestionLabel>                
        )
    }

    private setChildAge = (ageInMonths: number) => {
        this.props.onDetailsUpdated({
            ...this.props.enrolledChild,
            ageInMonths
        });
    }

    private setWeeklySessions = (rawValue: string) => {
        const attendSessionsPerWeek = parseInt(rawValue);
        this.props.onDetailsUpdated({
            ...this.props.enrolledChild,
            attendSessionsPerWeek
        });
    }
}
